module.exports = __webpack_public_path__ + "static/media/image_pc.528a15fb.jpg";